class LWDiv extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    static get observedAttributes() {
        return ['bg-color', 'bg-img', 'gradient', 'opacity', 'padding'];
    }

    connectedCallback() { this.render(); }
    attributeChangedCallback() { this.render(); }

    render() {
        const bgColor = this.getAttribute('bg-color') || 'transparent';
        const bgImg = this.getAttribute('bg-img') || '';
        const gradient = this.getAttribute('gradient') || '';
        const opacity = this.getAttribute('opacity') || '1';
        const padding = this.getAttribute('padding');
        const padMobile = padding ?? '30px';
        const padDesktop = padding ?? '80px';

        let background = bgColor;

        if (gradient) {
            const colors = gradient.split(',').map((color) => color.trim());
            background = `linear-gradient(to bottom, ${colors[0]} 0%, ${colors[1]} 30%, ${colors[2]} 100%)`;
        }

        if (bgImg) {
            background = `url('${bgImg}') center / cover no-repeat`;
        }

        this.shadowRoot.innerHTML = /* html */ `
        <style>
            :host {
                display: block;
                width: 100%;
                height: 100%;
                --lw-pad: ${padMobile};
                --lw-bg: ${background};
                --lw-opacity: ${opacity};
            }

            .content-wrapper {
                width: 100%;
                min-height: 100%;
                padding: var(--lw-pad);
                box-sizing: border-box;
                background: var(--lw-bg);
                opacity: var(--lw-opacity);
                display: flex;
                flex-direction: column;
            }

            @media (min-width: 600px) {
                :host {
                    --lw-pad: ${padDesktop};
                }
            }
        </style>
        <div class="content-wrapper">
            <slot></slot>
        </div>
        `;
    }
}
customElements.define('lw-div', LWDiv);